import { FilterTypeEnum } from '../enums/filter-type.enum';

export class QueryParameterRequest{

    constructor(name: string, value: any, required: boolean, systemType: string, filterType: FilterTypeEnum) {
        this.ParameterName = name;
        this.Value = value;
        this.Required = required;
        this.SystemType = systemType;
        this.FilterType = filterType;
    }
    ParameterName: string;
    Value: any;
    Required: boolean;
    SystemType: string;
    FilterType?: FilterTypeEnum;
}
